import React, { useState } from 'react';
import { FormContainer, InputGroup, Label, Input, ErrorMessage, ForgotPasswordLink, SuccessMessage, ForgotPasswordContainer } from '../../styles/auth/Login.styles';
import { Button } from '../shared/Button';

interface LoginFormProps {
  onForgotPassword?: (email: string) => Promise<void>;
  forgotPasswordLoading?: boolean;
  forgotPasswordMessage?: string;
  onSubmit: (email: string, password: string) => Promise<void>;
  loading?: boolean;
  error?: string;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, loading = false, error, onForgotPassword, forgotPasswordLoading = false, forgotPasswordMessage }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError('');

    if (!email || !password) {
      setFormError('Please fill in all fields');
      return;
    }

    if (!email.includes('@')) {
      setFormError('Please enter a valid email address');
      return;
    }

    try {
      await onSubmit(email, password);
    } catch (err) {
      setFormError(err instanceof Error ? err.message : 'Login failed');
    }
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <InputGroup>
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
          required
        />
      </InputGroup>

      <InputGroup>
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
          required
        />
      </InputGroup>

      {(error || formError) && (
        <ErrorMessage>
          {error || formError}
        </ErrorMessage>
      )}

      {forgotPasswordMessage && (
        <SuccessMessage>
          {forgotPasswordMessage}
        </SuccessMessage>
      )}

      <ForgotPasswordContainer>
        <ForgotPasswordLink
          href="#"
          $disabled={forgotPasswordLoading}
          onClick={(e) => {
            e.preventDefault();
            if (email && onForgotPassword) {
              onForgotPassword(email);
            } else {
              setFormError('Please enter your email first');
            }
          }}
        >
          {forgotPasswordLoading ? 'Sending...' : 'Forgot your password?'}
        </ForgotPasswordLink>
      </ForgotPasswordContainer>

      <Button
        type="submit"
        variant="primary"
        size="large"
        loading={loading}
        disabled={loading}
      >
        Sign In
      </Button>
    </FormContainer>
  );
};
